@if (auth.isLoading$ | async) {
  <div class="shell loading-shell">
    <p>Loading authentication context...</p>
  </div>
} @else {
  @if (auth.isAuthenticated$ | async) {
    <div class="shell">
      <header class="app-header">
        <div class="brand">
          <img class="brand-logo" src="favicon.svg" alt="Southbound CMS logo" width="64" height="64" />
          <div class="brand-copy">
            <h1>Southbound CMS</h1>
            @if (activeSiteName) {
              <p class="brand-context">Viewing {{ activeSiteName }}</p>
            }
          </div>
        </div>

        <div class="user-menu-shell" (click)="$event.stopPropagation()">
          <button
            type="button"
            class="user-menu-trigger"
            [attr.aria-expanded]="userMenuOpen"
            aria-haspopup="menu"
            (click)="toggleUserMenu($event)">
            @if (gravatarUrl) {
              <img class="user-avatar" [src]="gravatarUrl" alt="" width="40" height="40" />
            }
            <span class="user-summary">
              <strong>{{ currentUser?.name || currentUser?.email }}</strong>
              <span class="user-summary-site">{{ activeSiteName || currentUser?.email }}</span>
            </span>
            <span class="user-menu-caret" aria-hidden="true">{{ userMenuOpen ? '⌃' : '⌄' }}</span>
          </button>

          @if (userMenuOpen) {
            <section class="user-menu-panel" role="menu">
              <div class="user-menu-profile">
                @if (gravatarUrl) {
                  <img class="user-avatar user-avatar--large" [src]="gravatarUrl" alt="" width="56" height="56" />
                }
                <div>
                  <p class="eyebrow">Signed in</p>
                  <strong>{{ currentUser?.name || currentUser?.email }}</strong>
                  <p>{{ currentUser?.email }}</p>
                </div>
              </div>

              <button type="button" class="user-menu-field user-menu-site-button" (click)="openSiteDialog()">
                <span>Active site</span>
                <strong>{{ activeSiteName || 'No site selected' }}</strong>
                <span class="user-menu-field-hint">
                  @if (sites.length) {
                    Change site
                  } @else {
                    No sites available
                  }
                </span>
              </button>

              <div class="user-menu-actions">
                <button type="button" class="ghost small" [disabled]="!activeSiteId" (click)="openActiveSiteWorkspace()">Open site workspace</button>
                <button type="button" class="ghost small" (click)="openSites()">Sites</button>
                <button type="button" class="danger small" (click)="doLogout()">Logout</button>
              </div>
            </section>
          }
        </div>
      </header>

      <cms-menu />
      <main class="app-main">
        <router-outlet />
      </main>
    </div>
  } @else {
    <main class="shell public-shell">
      <section class="auth-panel">
        <p class="eyebrow">Southbound CMS</p>
        <h1>Sign in</h1>

        <div class="auth-form">
          <label>
            <span>Email</span>
            <input
              #emailInput
              type="email"
              [(ngModel)]="email"
              placeholder="editor@example.com"
              autocomplete="email"
              (keydown.enter)="onEmailEnter($event)" />
          </label>

          @if (otpRequested) {
            <label>
              <span>Code</span>
              <input
                #codeInput
                type="text"
                [ngModel]="code"
                (ngModelChange)="onCodeChange($event)"
                inputmode="numeric"
                maxlength="6"
                placeholder="123456"
                autocomplete="one-time-code"
                (keydown.enter)="onCodeEnter($event)" />
            </label>
          }

          @if (infoMessage) {
            <p class="auth-message auth-message--info">{{ infoMessage }}</p>
          }

          @if (errorMessage) {
            <p class="auth-message auth-message--error">{{ errorMessage }}</p>
          }

          <div class="auth-actions">
            <button type="button" class="ghost" (click)="requestOtp()" [disabled]="requestingOtp || verifyingOtp">
              {{ otpRequested ? 'Resend code' : 'Email code' }}
            </button>
            <button type="button" class="accent" (click)="verifyOtp()" [disabled]="!otpRequested || requestingOtp || verifyingOtp">
              Verify code
            </button>
          </div>
        </div>
      </section>
    </main>
  }
}

@if (siteDialogOpen) {
  <div class="dialog-backdrop" (click)="closeSiteDialog()">
    <section
      class="dialog-panel site-dialog-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="active-site-dialog-title"
      (click)="$event.stopPropagation()">
      <header class="dialog-header">
        <div>
          <p class="eyebrow">Site context</p>
          <h2 id="active-site-dialog-title">Change active site</h2>
        </div>
        <button type="button" class="ghost small" (click)="closeSiteDialog()">Close</button>
      </header>

      @if (sites.length) {
        <div class="site-dialog-list">
          @for (site of sites; track site.id) {
            <button
              type="button"
              class="site-dialog-option"
              [class.is-active]="site.id === activeSiteId"
              (click)="selectActiveSite(site.id)">
              <span class="site-dialog-copy">
                <strong>{{ site.name }}</strong>
                <span>{{ site.landingPageCount }} landing pages, {{ site.linkCount }} links</span>
              </span>
              <span class="site-dialog-state">{{ site.id === activeSiteId ? 'Active' : 'Select' }}</span>
            </button>
          }
        </div>
      } @else {
        <p class="empty-state">No sites available yet.</p>
      }
    </section>
  </div>
}
